import React, { FunctionComponent, CSSProperties } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import OutageMapLegendIconProps from './OutageMapLegendIcon.types';

const basicStyle: CSSProperties = {
  fill: '#1C304A',
};

const OutageMapLegendIcon: FunctionComponent<OutageMapLegendIconProps> = ({
  className,
  color,
  viewBox,
}) => {
  const style = { ...basicStyle, fill: color || '#1C304A' };
  return (
    <SvgIcon viewBox={viewBox} className={className ? className : ''}>
      <g transform="translate(0.353 -50)">
        <rect rx="20" transform="translate(-0.353 50)" />
        <g transform="translate(-0.353 50)">
          <rect fill="#fff" transform="translate(0 0)" />
          <path
            style={style}
            d="M8.99-2.46,1.62-8.19,0-6.93l9,7,9-7L16.37-8.2ZM9-5l7.36-5.73L18-12,9-19,0-12l1.63,1.27Z"
            transform="translate(11 29.465)"
          />
        </g>
      </g>
    </SvgIcon>
  );
};

export default OutageMapLegendIcon;
